import Route from "@/scripts/routeRegistrar"
const RouteRegistrar = new Route('payment');

RouteRegistrar.add("payment/paymethods/Paymethods", "paymethods", "paymethods", "شیوه ها پرداخت")

RouteRegistrar.add("payment/transactions/Transactions", "transactions", "transactions", "لیست تراکنش ها")
RouteRegistrar.add("payment/wallet-transactions/Transactions", "wallet-transactions", "wallet-transactions", "لیست تراکنش ها")



const routes = RouteRegistrar.allRoutes()


export default routes;
